export enum GameOutcome {
  WIN = "Win",
  LOSS = "Loss",
}
